import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RDSendReportComponent} from './rd-send-report.component';


export const rdSendReportRoutes: Routes = [
  {
    path: 'rdSendReport',
    component: RDSendReportComponent,
    data: {
      'expectedRoles': ['Accountant Admin', 'IT', 'Accountant']
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(rdSendReportRoutes)],
  exports: [RouterModule]
})
export class RDSendReportRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/rd-send-report/rd-send-report-routing.module.ts